export var CELL_STRIDE = 2;
export var CELL_SIZE = 12;
//# sourceMappingURL=config.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/face-api.js/build/es6/mtcnn/config.js
// module id = 620
// module chunks = 0